import { Button } from "$components/button/button";
import { DialogBody } from "$components/dialog/dialog-body";
import { DialogContainer } from "$components/dialog/dialog-container";
import { DialogFooter } from "$components/dialog/dialog-footer";
import { DialogHeader } from "$components/dialog/dialog-header";
import { WarningIcon as _WarningIcon } from "$components/icons";
import { Box, styled, Typography } from "@material-ui/core";
import React from "react";
import { FormattedMessage } from "react-intl";

const WarningIcon = styled(_WarningIcon)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

const WarningWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.warning.light,
  borderRadius: theme.spacing(),
  padding: theme.spacing(),
  marginBottom: theme.spacing(2),
}));

const PasswordModal = ({ password }: { password?: string }) => {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    setOpen(!!password);
  }, [password]);

  return (
    <DialogContainer open={open}>
      <DialogHeader title="">
        <WarningWrapper display="flex" alignItems="center">
          <WarningIcon viewBox="0 0 32 32" />
          <Typography variant="h5">
            <FormattedMessage
              id="register.download.passwordModal.title"
              defaultMessage="This is the password for the downloaded file. You will need this to open the document. Please store the password in a safe space.{br} You are responsible for the security of all downloaded patient data"
              values={{ br: <br /> }}
            />
          </Typography>
        </WarningWrapper>
      </DialogHeader>
      <DialogBody style={{ display: "flex", justifyContent: "center" }}>
        <Typography variant="subtitle1">
          <FormattedMessage
            id="register.download.passwordModal.body"
            defaultMessage="Password for downloaded file:"
          />{" "}
          <strong>{password}</strong>
        </Typography>
      </DialogBody>
      <DialogFooter>
        <Button
          color="primary"
          onClick={() => {
            setOpen(false);
          }}
        >
          <FormattedMessage
            id="register.download.passwordModal.confirm"
            defaultMessage="I have safely recorded this password"
          />
        </Button>
      </DialogFooter>
    </DialogContainer>
  );
};

export default PasswordModal;
